import React, { useEffect, useRef, useState } from 'react';

const Slider = () => {
    const handRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <div className="theme_slider_1">
            <div className="slider">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="slide_content">
                                <h5 className="sub_heading">
                                    <i className="fa fa-phone-square" style={{ color: 'var(--red-color)', marginRight: '8px' }}></i>
                                    Chiamaci ora
                                    <span>
                                        <i className="fa fa-phone" style={{ marginRight: '5px' }}></i>
                                        +39 340 5327626
                                    </span>
                                </h5>
                                <h2 className="heading" style={{ color: 'var(--white-color)' }}>
                                    Realizziamo la casa dei tuoi sogni
                                </h2>
                                <p className="desc" style={{ color: 'var(--white-color)' }}>
                                    Professionalità, esperienza e qualità. Costruiamo la tua casa con passione e competenza.
                                </p>
                                <div className="slider_button">
                                <a href="tel:393405327626" className="button button_border" style={{
                                        color: 'var(--red-color)',
                                        borderColor: 'var(--red-color)'
                                    }}>
                                        <i className="fa fa-phone me-2"></i>
                                        Contattaci
                                    </a>
                                    <a href="/chi-siamo" className="button" style={{
                                        backgroundColor: 'var(--white-color)',
                                        borderColor: 'var(--red-color)'
                                    }}>
                                        <i className="fa fa-info-circle me-2"></i>
                                        Chi siamo
                                    </a>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex align-items-end">
                            <div 
                                className={`layer_object ${isVisible ? 'visible' : ''}`} 
                                ref={handRef} 
                                style={{
                                    transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
                                    opacity: isVisible ? 1 : 0,
                                    transition: 'transform 0.8s ease-out, opacity 0.8s ease-out'
                                }}
                            >
                                <img 
                                    src="/images/slider/house-on-hand.png" 
                                    style={{
                                        width: '100%', 
                                        height: 'auto', 
                                        maxWidth: '600px'
                                    }}
                                    alt="house on hand" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Slider;